import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

interface SmsData {
  recipient: string;
  message: string;
  extensionId: string;
}

@Injectable({
  providedIn: 'root'
})
export class SipgateService {
  private apiUrl = environment.prismaApiUrl + '/api/dispo/sipgate';

  constructor(private http: HttpClient) {}

  sendSms(smsData: SmsData): Observable<any> {
    // Formatiere die Daten für die API
    const formattedData = {
      recipient: smsData.recipient,
      message: smsData.message,
      extensionId: smsData.extensionId
    };

    return this.http.post(`${this.apiUrl}/sms`, formattedData);
  }

  getSmsHistory(limit: number = 50, offset: number = 0): Observable<any> {
    return this.http.get(`${this.apiUrl}/history`, {
      params: {
        limit: limit.toString(),
        offset: offset.toString()
      }
    });
  }

  getExtensions(): Observable<any> {
    return this.http.get(`${this.apiUrl}/extensions`);
  }

  getCallHistory(limit: number, offset: number): Observable<any> {
    return this.http.get(environment.prismaApiUrl + '/api/dispo/stats', {
      params: {
        history_limit: limit,
        history_offset: offset
      }
    });
  }

  testWavCall(): Observable<any> {
    // Temporär: Verwende die bestehende SMS-Route für den Test
    return this.http.post(`${this.apiUrl}/sms`, {
      recipient: '+491637944060',
      message: 'TEST WAV CALL',
      extensionId: 'test'
    });
  }

  // IVR - Telefon-IVR für Terminbestätigung
  startAppointmentConfirmation(data: {
    phone_number: string;
    appointment_id: number;
    appointment_date: string;
    appointment_time: string;
  }): Observable<any> {
    return this.http.post(`${this.apiUrl.replace('/sipgate', '/ivr')}/start-appointment-confirmation`, data);
  }

  testIvr(): Observable<any> {
    return this.http.get(`${this.apiUrl.replace('/sipgate', '/ivr')}/test`);
  }

  getWavFiles(): Observable<any> {
    return this.http.get(`${this.apiUrl.replace('/sipgate', '/ivr')}/wav-files`);
  }

  testWebhook(): Observable<any> {
    return this.http.get(`${this.apiUrl}/test-webhook`);
  }

  /** Aktive Anrufe (für Dashboard „Wer telefoniert gerade“). */
  getActiveCalls(): Observable<{ success: boolean; incoming_calls: any[]; total_calls: number }> {
    if (!environment.telephonyEnabled) {
      return new Observable((observer) => {
        observer.next({ success: true, incoming_calls: [], total_calls: 0 });
        observer.complete();
      });
    }
    return this.http.get<{ success: boolean; incoming_calls: any[]; total_calls: number }>(
      `${this.apiUrl}/active-calls`
    );
  }

  endCall(callId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/end-call/${callId}`, {});
  }

  // WebSocket/Event Handling für eingehende Anrufe
  subscribeToIncomingCalls(): Observable<any> {
    // Wenn Telephony deaktiviert ist, keine Polling-Intervalle starten
    if (!environment.telephonyEnabled) {
      return new Observable((observer) => {
        observer.complete();
      });
    }
    // Hier würden Sie normalerweise WebSocket-Verbindung implementieren
    // Für jetzt verwenden wir Polling
    return new Observable(observer => {
      const interval = setInterval(() => {
        this.getActiveCalls().subscribe(
          (response) => {
            if (response.success && response.incoming_calls.length > 0) {
              observer.next(response.incoming_calls);
            }
          },
          (error) => observer.error(error)
        );
      }, 5000); // Alle 5 Sekunden prüfen

      return () => clearInterval(interval);
    });
  }
} 